import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link, withRouter} from 'react-router-dom';
import styled from 'styled-components';
import {compose} from "redux";
// import { useParams } from 'react-router-dom';
import {withTheme} from './../../../themes';
import {refreshLetzfairAuthData} from './../../../helpers';
import {getLocale, getTranslations} from "./../../../store/localization/selectors";
import {getConfig, getLayout,} from './../../../store/settings/selectors';
import {
    getCompanyData,
    getFavorites,
    getIsPremiumUser,
    getLetsfairData,
    // getRoles
} from './../../../store/auth/selectors';
import {getActiveCompanies} from "../../../store/chat/selectors";
import { sortHallAndBooth } from './../../../utils/hallAndBooth';
// import { DOMAINS } from "./../../../domains";
import {LAYOUT_MD, LAYOUT_SM, LAYOUT_XS} from './../../../settings'
import LabelledValue from "./../../../components/Common/LabelledValue"
import Container from './../../../components/App/Container';
import Spacer from './../../../components/App/Spacer';
import Chunk from './../../../components/App/Chunk';
import InfoRow from './../../../components/App/InfoRow';
import Gallery from './../../../components/App/Gallery';
import Image from './../../../components/App/Image';
import Button from './../../../components/App/Button';
import List from './../../../components/App/List';
import Icon from './../../../components/App/Icon';
import Modal from './../../../components/App/Modal/Modal';
// import Logo from "./../../../components/App/Logo";
import ReadMore from "./../../../components/App/ReadMore";
import ReadMoreModal from "./../../../components/App/ReadMoreModal";
import Actionbar from "./../../../components/Common/Actionbar";
// import FullModal from "./../../../components/Common/FullModal";
import Meta from "./../../../components/App/Meta";

import Result from './../../../components/List/Sidebar/ResultsList/Result';
import CompanyResult from './../Companies/CompanyResult';
import ProductThumb from './../Products/ProductThumb';
// import EventThumb from './../Events/EventThumb';
import ContactForm from "./../../../components/Common/ContactForm";
import FindUs from "./../../../components/Common/FindUs";
import {getPermissions, getUser} from "./../../../store/auth/selectors";
import {getCompanyActive} from "../../../store/chat/actions";

// import {showPlansModal} from "../../../store/settings/actions";

// import {PERMISSION_CHAT, PERMISSION_FAVOURITES, PERMISSION_NOTES} from "../../../store/auth/permissions";
import {setFavorite} from "../../../store/auth/actions";
// import LetsFair from "../../../components/LetsFair/LetsFair"; //questo va nella popup

import {showFullModal, hideFullModal} from "./../../../store/settings/actions";
import {DOMAINS} from "../../../domains";
import HospitalityFacilities from '../../../components/Vir/HospitalityFacilities';


const Fixed = styled.div`
  width: 100%;
  position: sticky;
  top: 0px;
  z-index: 999;
  background: #F2F4F4;
`;
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  min-height: 100%;
`;
const MainContainer = styled.div`
  margin-top: 3px;
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  min-height: 100%;
`;
const Title = styled.h1`
  font-weight: bold;
  font-size: 14px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`;

const MacroRow = styled.div`
  display: flex;
  flex-direction: ${props => props.layout === LAYOUT_XS || props.layout === LAYOUT_SM ? "column" : "row"};
  flex-wrap: wrap;
  margin-right: -${props => props.size && (props.layout === LAYOUT_MD) ? 7 : 12}px;
  margin-left: -${props => props.size && (props.layout === LAYOUT_MD) ? 7 : 12}px;

`;
const MacroCol = styled.div`
  padding: 0px ${props => props.size && (props.layout === LAYOUT_MD) ? 7 : 12}px;
  width: ${props => props.size && (props.layout !== LAYOUT_XS && props.layout !== LAYOUT_SM) ? props.size : 100}%;
`;
const Row = styled.div`
  display: flex;
  flex-direction: ${props => props.layout === LAYOUT_XS || props.layout === LAYOUT_SM ? "column" : "row"};
  flex-wrap: wrap;
  margin-right: -7px;
  margin-left: -7px;

`;
const Col = styled.div`
  padding: 0px 7px;
  width: ${props => props.size && (props.layout !== LAYOUT_XS && props.layout !== LAYOUT_SM) ? props.size : 100}%;
`;
// const Center = styled.div`
//   text-align: center;
//   display: flex;
//   justify-content: space-around;
// }
// `;

// const SlickSlide = styled.div`
//   padding: 0 8px;
//   box-sizing: border-box;
// `;

const Text = styled.div`
  column-count: ${props => props.cols && (props.layout !== LAYOUT_XS && props.layout !== LAYOUT_SM) ? props.cols : 1};

  & a:hover {
    font-weight: bold;
  }
`;

const ContactsModal = styled.div`
  width: 100%;
  max-width: 500px;
  background: #fff;
  padding: 30px;
`;

const ContactsModalHeader = styled.div`
  text-align: center;
  margin-bottom: 30px;
`;

const SocialLink = styled.span`
  position: relative;
  top: -6px;
`;

const Position = styled.div`
  display: inline-block;
  background: #7B3572;
  color: #fff;
  text-align: center;
  padding: 8px 22px;
  border-radius: 5px;
  font-size: 15px;
  margin-bottom: 10px;
`;

const HallImageCnt = styled.div`
  position: relative;
`;
const HallImage = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
`;
const ListHighlight = styled.div`
  text-trasform: uppercase;
  color: #7B3572;
  font-size: 13px;
  font-weight: 700;
`;

// const HallTitle = styled.div`
//   color: #7B3572;
//   font-size: 12px;
//   font-weight: 700;
// `;
// const HallText = styled.div`
//   color: #585858;
//   font-size: 12px;
//   margin-bottom: 10px;

// `;

const MeetingModal = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  max-width: 80%;
  margin: 0 auto;
  min-height: 100%;
  text-align: center;
`;
const MeetingModalText = styled.div`
  color: #585858;
  font-size: 12px;
  margin-bottom: 60px;

  & a {
    color: #7B3572;
  }
`;

const RelationsModal = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;
const RelationsModalTitle = styled.div`
  color: #7B3572;
  font-size: 15px;
  line-height: 18px;
  font-weight: 700;
  border-bottom: 1px solid #dedede;
  padding-bottom: 20px;
  margin-bottom: 20px;
`;
const RelationsModalContent = styled.div`
  width: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  & > * {
    flex-basis: ${props => props.layout !== LAYOUT_XS && props.layout !== LAYOUT_SM ? "calc(33.333333% - 12px)" : "100%"};
    margin-bottom: 15px;
  }
`;

const CategoryItem = styled.div`
  font-size: 13px;
  margin-bottom: 30px;
  color: #666;
`;

const mapStateToProps = (state) => ({
    translations: getTranslations(state),
    config: getConfig(state),
    layout: getLayout(state),
    user: getUser(state),
    lang: getLocale(state),
    permissions: getPermissions(state),
    isPremiumUser: getIsPremiumUser(state),
    favorites: getFavorites(state),
    activeCompanies: getActiveCompanies(state),
    companyData: getCompanyData(state),
    letsfairData: getLetsfairData(state)
});

const mapDispatchToProps = (dispatch) => ({
    dispatch,
});

class CompanySheet extends Component {

    state = {
        showModal: null,
        chatEnabled: false,
        isAgendaLoading: false,
        openCategories: {}
    }

    toggleCategory = (id) => {
        this.setState(prevState => ({
            openCategories: {
                ...prevState.openCategories,
                [id]: !prevState.openCategories[id]
            }
        }));
    }

    sectionReferences = null;

    constructor(props) {
        super(props);
        this.props = props;

        this.toggleModal = this.toggleModal.bind(this);
    }

    componentDidMount() {

        if (!this.props.activeCompanies.hasOwnProperty(this.props.data.id)) {
            this.props.dispatch(getCompanyActive(this.props.data.id));
        }

    }

    componentDidUpdate(prevProps) {
    }

    toggleModal(modal) {
        this.setState({
            showModal: modal
        })
    }


    likeHandler = (favorites) => {

        this.props.dispatch(setFavorite({
            area: 'exhibitor',
            idElement: this.props.data.id,
            isFavorite: favorites && favorites.filter(item => item.itemType === "exhibitor" && item.itemId === this.props.data.id).length > 0
        }));

    }

    memoHandler = () => {
    }

    isCompanyActive = () => {
        const {activeCompanies, data} = this.props;
        return activeCompanies && data && activeCompanies.hasOwnProperty(data.id) && activeCompanies[data.id];
    }

    agendaHandler = async () => {
        if (this.state.isAgendaLoading) return;
        
        this.setState({ isAgendaLoading: true });
        
        let {letsfairData, data} = this.props;
        console.log('letsfairData', letsfairData);
        if (letsfairData && window.letzfair) {
            try {
                await refreshLetzfairAuthData();
            } catch (error) {
                // Errore già loggato in refreshLetzfairAuthData
            } finally {
                this.setState({ isAgendaLoading: false });
            }
            
            letsfairData = {
                ...letsfairData,
                espositore: data.options.name,
                idEspositore: data.id,
                idCompany: data.scope.companyId,
                logoEspositore: data.options.logo ? data.options.logo.src : null,
            }
            
            this.props.dispatch(hideFullModal());
            window.letzfair('meeting', letsfairData);
        } else {
            this.setState({ isAgendaLoading: false });
        }
    }

    render() {
        const {props} = this;

        const theme = props.theme;
        const {data, translations, lang, config, layout, user, favorites, isPremiumUser} = props;
        const {showModal} = this.state;

        if (!data) return null;

        const hallAndBooth = data.servicesData && data.servicesData.location && data.servicesData.location.hallAndBooth ?
            sortHallAndBooth(data.servicesData.location.hallAndBooth) : null;

        const itemOptions = data.options;
        const isWineProducer = itemOptions?.typologyProfile?._id === "ProfileType_Vino";
        const isSpiritsDrinksProducer = itemOptions?.typologyProfile?._id === "ProfileType_SpiritsDrinks";
        const isBeerProducer = itemOptions?.typologyProfile?._id === "ProfileType_Birra";

        const formattedBrandPositioning = (() => {
            if (!itemOptions?.brandsPositioning) return [];
            const grouped = itemOptions.brandsPositioning.reduce((acc, bp) => {
                const positioningLabel = bp.positioning[lang];
                if (!acc[positioningLabel]) acc[positioningLabel] = [];
                acc[positioningLabel].push(bp.name);
                return acc;
            }, {});
            return Object.entries(grouped).map(([positioning, brands]) => ({ positioning, brands }));
        })();

        const formattedProductSpiritCategories = (() => {
            if (!itemOptions?.productSpiritCategories) return [];
            const grouped = itemOptions.productSpiritCategories.reduce((acc, item) => {
                const categoryLabel = item.category[lang];
                const categoryId = item.category._id;
                if (!acc[categoryId]) {
                    acc[categoryId] = { category: categoryLabel, products: [] };
                }
                if (item.product) acc[categoryId].products.push(item.product[lang]);
                return acc;
            }, {});
            return Object.values(grouped);
        })();

        const productCategories = itemOptions?.productCategories
            ? itemOptions.productCategories.map(category => category[lang]).join(', ')
            : '';

        let modalText = '';

        if (showModal) {
            modalText = translations['sheet-company'][`_intro-contatto-diretto-${showModal.type}`].replace('%s', showModal.name);
        }

        return data ? (
            <>
                <Meta
                    title={data.options.name}
                    description={
                        data.options.name + " " +
                        (data.options.locations && data.options.locations.length > 0 ? (
                            data.options.locations[0].city + " " +
                            (data.options.locations[0].countryId ? data.options.locations[0].countryId[lang] : null) + " "
                        ) : null) +
                        (data.options.sustainability && data.options.sustainability.length > 0 ? data.options.sustainability.map(val => val[lang]).join(", ") : null) + " " +
                        (data.options.certificates && data.options.certificates.length > 0 ? data.options.certificates.map(val => val[lang]).join(", ") : null)
                    }
                    image={data.options.logo && data.options.logo.src ? data.options.logo.src : null}
                />
                <Fixed>
                    <Container>
                        <Actionbar list={[
                            {
                                name: translations["UI"]["Memo"],
                                icon: theme.icons.set.memo,
                                onClick: this.memoHandler,
                                show: false,
                                isActive: false,
                                isDisabled: false
                            }, {
                                name: favorites && favorites.filter(item => item.itemType === "exhibitor" && item.itemId === this.props.data.id).length ? translations["UI"]["Liked"] : translations["UI"]["Like"],
                                icon: theme.icons.set.favorite,
                                onClick: () => this.likeHandler(favorites),
                                show: true,
                                isActive: favorites && favorites.filter(item => item.itemType === "exhibitor" && item.itemId === this.props.data.id).length,
                                isDisabled: false
                            }, 
                            {
                                name: translations["UI"]["Contact"],
                                icon: theme.icons.set.contact,
                                onClick: () => {
                                    const emails = data.options.contacts
                                        .filter((item) => item.classification._id === "email")
                                        .map((item) => item.value);
                                    if (emails.length > 0) {
                                        window.location.href = `mailto:${emails[0]}`;
                                    }
                                },
                                show: data.options.contacts && data.options.contacts.filter((item) => item.classification._id === "email").length,
                                isActive: false,
                                isDisabled: false
                            },
                            {
                                name: translations["UI"]["Save"],
                                icon: theme.icons.set.calendar,
                                onClick: null,
                                show: false,
                                isActive: false,
                                isDisabled: false
                            }, {
                                name: translations["UI"]["Meeting"],
                                icon: theme.icons.set.calendar,
                                onClick: () => this.props.dispatch(showFullModal(
                                    <MeetingModal>
                                        <div>
                                            <MeetingModalText
                                                dangerouslySetInnerHTML={{__html: translations["sheet-company"]["_meeting-text"]}}></MeetingModalText>
                                            <div>
                                                <Button onClick={this.agendaHandler} variant={"default"}
                                                        display={"inline"}
                                                        isLoading={this.state.isAgendaLoading}
                                                        disabled={this.state.isAgendaLoading}>{translations["sheet-company"]["_meeting-button"]}</Button>
                                            </div>
                                        </div>
                                    </MeetingModal>
                                )),
                                show: (
                                    DOMAINS[window.location.hostname].enable_agenda && (data?.servicesData?.agenda?.enableAgenda || data?.id === 'NXuPSLHPxkSJdVB-wDYFww') 
                                    // && (user?.email === 'bonesini@gmail.com' || user?.email === 'norbertghioane@icloud.com' || user?.email === 'stefano.occhi@24consulting.it')
                                ),
                                isActive: (user && user?.id && isPremiumUser),
                                isDisabled: !(user && user?.id && isPremiumUser) || (user?.id === "N1CRqIyCb0uZ2DxEpMas6A") // ZENATO
                            }
                        ]}/>
                    </Container>
                </Fixed>
                <Wrapper>
                    <MainContainer>
                        <Container>

                            <Title>
                                <Icon color={"#606060"} name={theme.icons.set.homepage}
                                      size={{value: 25, unit: "px"}}/>&nbsp;&nbsp;
                                {data.options.name}
                            </Title>
                            <Spacer size={{value: 12, unit: "px"}}/>

                            <MacroRow layout={layout}>
                                <MacroCol size="66" layout={layout}>
                                    {data.options.logo || data.options.headerImage ?
                                        <>
                                            <Row layout={layout}>
                                                {data.options.logo ?
                                                    <Col size={data.options.headerImage ? 50 : 100} layout={layout}>
                                                        <Chunk open={true} collapsible={false} fullHeight={true}>
                                                            <Image fit={"contain"} height={{"value": 100, "unit": "px"}}
                                                                   src={data.options.logo.src}
                                                                   alt="logo"/>
                                                        </Chunk>
                                                    </Col>
                                                    : null}
                                                {layout !== LAYOUT_XS && layout !== LAYOUT_SM ?
                                                    null
                                                    :
                                                    <Spacer size={{value: 12, unit: "px"}}/>
                                                }
                                                {data.options.headerImage ?
                                                    <Col size={data.options.logo ? 50 : 100} layout={layout}>
                                                        <Chunk open={true} collapsible={false} fullHeight={true}
                                                               noPadding={true}>
                                                            <Image width={{value: 100, unit: "%"}} height={
                                                                layout !== LAYOUT_XS && layout !== LAYOUT_SM ?
                                                                    (data.logo ? {
                                                                        "value": 100,
                                                                        "unit": "%"
                                                                    } : {"value": 150, "unit": "px"})
                                                                    :
                                                                    {"value": 150, "unit": "px"}
                                                            } src={data.options.headerImage.src} alt="cover"/>
                                                        </Chunk>
                                                    </Col>
                                                    : null}
                                            </Row>
                                            <Spacer size={{value: 14, unit: "px"}}/>
                                        </>
                                        : null}
                                    <Chunk title={translations["sheet-company"]["Contacts"]}>
                                        {data.options.contacts && data.options.contacts.filter((item) => item.classification._id === "email").length > 0 ?
                                            <InfoRow
                                                label={translations["sheet-company"]["Email"]}
                                                value={
                                                    <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end" }}>
                                                        {data.options.contacts
                                                            .filter(item => item.classification._id === "email")
                                                            .map((item, i) => (
                                                                <span key={`email-${i}`}>
                                                                    <Button
                                                                        display="inline-block"
                                                                        variant="default-inverse"
                                                                        size="tiny"
                                                                        onClick={() => {
                                                                            window.location.href = `mailto:${item.value}`;
                                                                        }}
                                                                    >
                                                                        {item.value}<br />
                                                                    </Button>
                                                                </span>
                                                            ))}
                                                    </div>
                                                }
                                            />
                                            : null}
                                        {data.options.locations && data.options.locations.length > 0 ?
                                            <InfoRow
                                                label={translations["sheet-company"]["Address"]}
                                                value={data.options.locations.map((val, i) =>
                                                    <React.Fragment key={`location-${i}`}>
                                                        {val.classification && val.classification[lang] ? <>
                                                            <b>{val.classification[lang]}</b><br/></> : null}
                                                        {val.address}<br/>
                                                        {val.city} {val.zip} {val.provinceId ? val.provinceId[lang] : null}<br/>
                                                        {val.countryId ? val.countryId[lang] : null}<br/>
                                                        {i < data.options.locations.length - 1 ? <br/> : null}
                                                    </React.Fragment>
                                                )}
                                            />
                                            : null}
                                        {data.options.languages && data.options.languages.length > 0 ?
                                            <InfoRow
                                                label={translations["sheet-company"]["Languages spoken"]}
                                                value={data.options.languages.map(val =>
                                                    <span key={`language-${val[lang]}`}>{val[lang]}<br/></span>
                                                )}
                                            />
                                            : null}
                                        {data.options.contacts && data.options.contacts.filter((item) => item.classification._id === "web").length > 0 ?
                                            <InfoRow
                                                label={translations["sheet-company"]["Website"]}
                                                value={data.options.contacts.filter((item) => item.classification._id === "web").map(val =>
                                                    <a href={val.value}
                                                       key={`website-${val.value}`}>{val.value}<br/></a>
                                                )}
                                            />
                                            : null}
                                        {data.options.contacts && data.options.contacts.filter((item) => item.subtype._id === "phone;phone-tel").length > 0 ?
                                            <InfoRow
                                                label={translations["sheet-company"]["Phone"]}
                                                value={data.options.contacts.filter((item) => item.subtype._id === "phone;phone-tel").map(val =>
                                                    <span key={`phones-${val.value}`}>{val.value}<br/></span>
                                                )}
                                            />
                                            : null}
                                        {data.options.contacts && data.options.contacts.filter((item) => item.subtype._id === "phone;phone-fax").length > 0 ?
                                            <InfoRow
                                                label={translations["sheet-company"]["Fax"]}
                                                value={data.options.contacts.filter((item) => item.subtype._id === "phone;phone-fax").map(val =>
                                                    <span key={`faxes-${val.value}`}>{val.value}<br/></span>
                                                )}
                                            />
                                            : null}
                                        {data.options.contacts && data.options.contacts.filter((item) => item.classification._id === "social").length > 0 ?
                                            <InfoRow label={translations["sheet-company"]["Social"]}>
                                                {data.options.contacts && data.options.contacts.filter((item) => item.classification._id === "social").map((item, i) =>
                                                    <a rel="noopener noreferrer" key={i} href={item.value}
                                                       target="_blank"><Icon color={"#606060"}
                                                                             name={(item.subtype._id.replace("social;", "")) + "-1"}
                                                                             size={{
                                                                                 value: 20,
                                                                                 unit: "px"
                                                                             }}/>
                                                        <SocialLink>{/*item.subtype[lang]*/}{item.value}</SocialLink><br/></a>
                                                )}
                                            </InfoRow>
                                            : ""}


                                    </Chunk>

                                    <Spacer size={{value: 14, unit: "px"}}/>
                                    {data.options.people && data.options.people.length > 0 ?
                                        <>
                                            <Chunk title={translations["sheet-company"]["About us"]} open={false}>

                                                <Row layout={layout}>
                                                    {["president", "ceo"].map((role, i) =>
                                                        data.options.people.filter(item => item.classification._id === role).length > 0 ?
                                                            <Col size="50" key={i}>
                                                                <LabelledValue
                                                                    label={data.options.people.filter(item => item.classification._id === role)[0].classification[lang]}
                                                                    border={false}>
                                                                    {data.options.people.filter(item => item.classification._id === role)[0].firstName + " " + data.options.people.filter(item => item.classification._id === role)[0].lastName}<br/><br/>
                                                                    {data.options.people.filter(item => item.classification._id === role)[0].contacts.filter((item) => item.classification._id === "email").length > 0 ?
                                                                        <Button onClick={() => this.toggleModal({
                                                                            type: 'companycontact',
                                                                            email: data.options.people.filter(item => item.classification._id === role)[0].contacts.filter((item) => item.classification._id === "email")[0].value,
                                                                            name: data.options.people.filter(item => item.classification._id === role)[0].firstName + " " + data.options.people.filter(item => item.classification._id === role)[0].lastName
                                                                        })} size={"tiny"} variant={"default-o"}
                                                                                display={"inline-block"}>{translations["sheet-company"]["Contact directly"]}</Button>
                                                                        : ""}
                                                                </LabelledValue>
                                                            </Col>
                                                            : null
                                                    )}
                                                    {data.options.people.filter(item => item.classification._id !== "president" && item.classification._id !== "ceo").length > 0 ?
                                                        data.options.people.filter(item => item.classification._id !== "president" && item.classification._id !== "ceo").map((person, i) =>
                                                            <Col size="25" key={i}>
                                                                <LabelledValue label={person.classification[lang]}
                                                                               border={false}>
                                                                    {person.firstName + " " + person.lastName}<br/><br/>
                                                                    {person.contacts.filter((item) => item.classification._id === "email").length > 0 ?
                                                                        <Button onClick={() => this.toggleModal({
                                                                            type: 'companycontact',
                                                                            email: person.contacts.filter((item) => item.classification._id === "email")[0].value,
                                                                            name: person.firstName + " " + person.lastName
                                                                        })} size={"tiny"} variant={"default-o"}
                                                                                display={"inline-block"}>{translations["sheet-company"]["Contact directly"]}</Button>
                                                                        : ""}
                                                                </LabelledValue>
                                                            </Col>
                                                        )
                                                        : null}
                                                </Row>
                                            </Chunk>
                                            <Spacer size={{value: 14, unit: "px"}}/>
                                        </>
                                        : null}

                                    {
                                        (itemOptions.brandIdentities && itemOptions.brandIdentities.length > 0) ||
                                        (itemOptions.ownerName) ||
                                        (itemOptions.foundationYear) ||
                                        (itemOptions.typology) ||
                                        /*(itemOptions.wineLabels) ||*/
                                        /*(itemOptions.brands && itemOptions.brands.length > 0) ||*/
                                        (formattedBrandPositioning && formattedBrandPositioning.length > 0) ||
                                        (itemOptions.openForTastings) ||
                                        (itemOptions.otherInfos && itemOptions.otherInfos.length > 0) ?
                                            <>
                                                <Chunk title={translations["sheet-company"]["Company info"]} >
                                                    {itemOptions.brandIdentities && itemOptions.brandIdentities.length > 0 ?
                                                        <InfoRow
                                                            label={translations["sheet-company"]["Identity"]}
                                                            value={itemOptions.brandIdentities.map((item) => item[lang]).join(", ")}
                                                        />
                                                        : ""}
                                                    {itemOptions.ownerName ?
                                                        <InfoRow
                                                            label={translations["sheet-company"]["Owner"]}
                                                            value={itemOptions.ownerName}
                                                        />
                                                        : ""}
                                                    {itemOptions.foundationYear ?
                                                        <InfoRow
                                                            label={translations["sheet-company"]["Foundation year"]}
                                                            value={itemOptions.foundationYear}
                                                        />
                                                        : ""}
                                                    {itemOptions.typology ?
                                                        <InfoRow
                                                            label={translations["sheet-company"]["Company typology"]}
                                                            value={itemOptions.typology[lang]}
                                                        />
                                                        : ""}
                                                    {/*itemOptions.wineLabels ?
                                                        <InfoRow
                                                            label={translations["sheet-company"]["Number of labels produced"]}
                                                            value={itemOptions.wineLabels}
                                                        />
                                                        : ""*/}
                                                    {/*itemOptions.brands && itemOptions.brands.length > 0 ?
                                                        <InfoRow
                                                            label={translations["sheet-company"]["Brands"]}
                                                            value={itemOptions.brands.join(", ")}
                                                        />
                                                        : ""*/}
                                                    {formattedBrandPositioning && formattedBrandPositioning.length > 0 && (
                                                        <InfoRow
                                                            label={translations["sheet-company"]["Brands"]}
                                                            value={
                                                                <div>
                                                                    {formattedBrandPositioning.map((group, idx) => (
                                                                        <div key={idx} style={{ marginBottom: "10px" }}>
                                                                            <Chunk title={group.positioning} open={true} collapsible={false} variant="minimal" fullHeight={true}>
                                                                                {group.brands.join(', ')}
                                                                            </Chunk>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            }
                                                        />
                                                    )}
                                                    {data.hospitality > 0 ?
                                                        <InfoRow
                                                            label={translations["sheet-company"]["Has hospitality"]}
                                                            value={translations["UI"]["Yes"]}
                                                        />
                                                        : ""}
                                                    {itemOptions.openForTastings ?
                                                        <InfoRow
                                                            label={translations["sheet-company"]["Open for tastings"]}
                                                            value={itemOptions.openForTastings[lang]}
                                                        />
                                                        : ""}
                                                    {itemOptions.otherInfos && itemOptions.otherInfos.length > 0 ?
                                                        <InfoRow
                                                            label={translations["sheet-company"]["Other information"]}
                                                            value={itemOptions.otherInfos.map(val => val[lang]).join(", ")}
                                                        />
                                                        : ""}
                                                </Chunk>
                                                <Spacer size={{value: 14, unit: "px"}}/>
                                            </>
                                            : null}

                                    {
                                        (itemOptions.categories && itemOptions.categories.length > 0 && isWineProducer) ||
                                        (itemOptions.typologyProfile && itemOptions.typologyProfile[lang]) ||
                                        (productCategories && (isWineProducer || isBeerProducer)) ||
                                        (isSpiritsDrinksProducer && formattedProductSpiritCategories && formattedProductSpiritCategories.length > 0) ||
                                        /*(itemOptions.specializations && itemOptions.specializations.length > 0) ||*/
                                        (itemOptions.productionAreas && itemOptions.productionAreas.length > 0) ||
                                        (isWineProducer && (itemOptions.hectares > 0 || itemOptions.hectaresManaged > 0 || itemOptions.hectaresOrganic > 0 || itemOptions.bottlesPerYear?.[lang])) ||
                                        ((isSpiritsDrinksProducer || isBeerProducer) && itemOptions.litersPerYear?.[lang]) ||
                                        /*(itemOptions.annualRevenue) ||*/
                                        /*(itemOptions.ownGrapesPercentage) ||*/
                                        /*(itemOptions.sustainability && itemOptions.sustainability.length > 0) ||*/
                                        (itemOptions.certificates && itemOptions.certificates.length > 0) ||
                                        /*(itemOptions.packaging && itemOptions.packaging.length > 0) ||*/

                                        (data.skills && data.skills.length > 0) ?
                                            <>
                                                <Chunk title={translations["sheet-company"]["Production"]}>
                                                    {itemOptions.typologyProfile && (
                                                        <InfoRow label={translations["sheet-company"]["Product type"]} value={itemOptions.typologyProfile[lang]} />
                                                    )}
                                                    {(isWineProducer || isBeerProducer) && productCategories && (
                                                        <InfoRow label={translations["sheet-company"]["Product categories"]} value={productCategories} />
                                                    )}
                                                    {isSpiritsDrinksProducer && formattedProductSpiritCategories && formattedProductSpiritCategories.length > 0 && (
                                                        <InfoRow
                                                            label={translations["sheet-company"]["Products"]}
                                                            value={
                                                                <div>
                                                                    {formattedProductSpiritCategories.map((group, idx) => (
                                                                        <div key={idx} style={{ marginBottom: "10px" }}>
                                                                            <Chunk title={group.category} open={true} collapsible={false} variant="minimal" fullHeight={true}>
                                                                                {group.products.join(', ')}
                                                                            </Chunk>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            }
                                                        />
                                                    )}
                                                    {itemOptions.categories && itemOptions.categories.length > 0 && isWineProducer ?
                                                        <InfoRow
                                                            label={translations["sheet-company"]["Denominations"]}
                                                            value={null}
                                                        >
                                                            <List>
                                                                <ul>
                                                                    {itemOptions.categories.map((lvl0, index0) =>
                                                                        <li key={index0}>
                                                                            <ListHighlight>{lvl0.value[lang]}</ListHighlight>
                                                                            {lvl0.children ?
                                                                                <ul>
                                                                                    {lvl0.children.map((lvl1, index1) =>
                                                                                        <li key={index1}>
                                                                                            {lvl1.value[lang]}
                                                                                            {lvl1.children ?
                                                                                                <ul>
                                                                                                    {lvl1.children.map((lvl2, index2) =>
                                                                                                        <li key={index2}>
                                                                                                            {lvl2.value[lang]}
                                                                                                            {lvl2.children ?
                                                                                                                <ul>
                                                                                                                    {lvl2.children.map((lvl3, index3) =>
                                                                                                                        <li key={index3}>
                                                                                                                            {lvl3.value[lang]}
                                                                                                                            {lvl3.children ?
                                                                                                                                <ul>
                                                                                                                                    {lvl3.children.map((lvl4, index4) =>
                                                                                                                                        <li key={index4}>{lvl4.value[lang]}</li>
                                                                                                                                    )}
                                                                                                                                </ul>
                                                                                                                                : ""}
                                                                                                                        </li>
                                                                                                                    )}
                                                                                                                </ul>
                                                                                                                : ""}
                                                                                                        </li>
                                                                                                    )}
                                                                                                </ul>
                                                                                                : ""}
                                                                                        </li>
                                                                                    )}
                                                                                </ul>
                                                                                : ""}
                                                                        </li>
                                                                    )}
                                                                </ul>
                                                            </List>
                                                        </InfoRow>
                                                        : ""}
                                                    {/*data.skills && data.skills.length > 0 ?
                                                        <InfoRow
                                                            label={translations["sheet-company"]["Specializations"]}
                                                            value={data.skills.join(", ")}
                                                        />
                                                        : ""*/}
                                                    {itemOptions.productionAreas && itemOptions.productionAreas.length > 0 ?
                                                        <InfoRow
                                                            label={translations["sheet-company"]["Production area"]}
                                                            value={
                                                                (
                                                                    itemOptions.productionAreas.map(valCountry => valCountry.countryId?.[lang])
                                                                        .filter((item, pos, self) => item && self.indexOf(item) === pos)
                                                                        .map(valCountry =>
                                                                            <span
                                                                                key={`production-area-${valCountry}`}>{valCountry}{itemOptions.productionAreas.filter(valRegion => valRegion.countryId?.[lang] === valCountry && valRegion.regionId !== null).length > 0 ? ": " + itemOptions.productionAreas.filter(valRegion => valRegion.countryId?.[lang] === valCountry && valRegion.regionId !== null).map(valRegion => valRegion.regionId?.[lang]).filter(r => r).join(", ") : null}
                                                                                <br/></span>
                                                                        )
                                                                )
                                                            }
                                                        />
                                                        : ""}
                                                    {isWineProducer && (
                                                        <>
                                                            {itemOptions.hectares > 0 && <InfoRow label={translations["sheet-company"]["Number of hectares owned"]} value={itemOptions.hectares.toString()} />}
                                                            {itemOptions.hectaresManaged > 0 && <InfoRow label={translations["sheet-company"]["Number of managed hectares"]} value={itemOptions.hectaresManaged.toString()} />}
                                                            {itemOptions.hectaresOrganic > 0 && <InfoRow label={translations["sheet-company"]["Number of hectares under organic farming"]} value={itemOptions.hectaresOrganic.toString()} />}
                                                            {itemOptions.bottlesPerYear && <InfoRow label={translations["sheet-company"]["Annual production in bottles"]} value={itemOptions.bottlesPerYear[lang]} />}
                                                        </>
                                                    )}
                                                    {(isSpiritsDrinksProducer || isBeerProducer) && itemOptions.litersPerYear && (
                                                        <InfoRow label={translations["sheet-company"]["Annual production in liters"]} value={itemOptions.litersPerYear[lang]} />
                                                    )}
                                                    {/*itemOptions.ownGrapesPercentage ?
                                                        <InfoRow
                                                            label={translations["sheet-company"]["Grapes"]}
                                                            value={translations["sheet-company"]["_own-grapes-percent"].replace(/%s/g, itemOptions.ownGrapesPercentage) + ", " + translations["sheet-company"]["_purchased-grapes-percent"].replace(/%s/g, 100 - itemOptions.ownGrapesPercentage)}
                                                        />
                                                        : ""*/}
                                                    {/*itemOptions.sustainability && itemOptions.sustainability.length > 0 ?
                                                        <InfoRow
                                                            label={translations["sheet-company"]["Sustainability"]}
                                                            value={itemOptions.sustainability.map(val => val[lang]).join(", ")}
                                                        />
                                                        : ""*/}
                                                    {itemOptions.certificates && itemOptions.certificates.length > 0 ?
                                                        <InfoRow
                                                            label={translations["sheet-company"]["Certifications"]}
                                                            value={itemOptions.certificates.map(val => val[lang]).join(", ")}
                                                        />
                                                        : ""}
                                                    {/*itemOptions.packaging && itemOptions.packaging.length > 0 ?
                                                        <InfoRow
                                                            label={translations["sheet-company"]["Available packaging"]}
                                                            value={itemOptions.packaging.map(val => val[lang]).join(", ")}
                                                        />
                                                        : ""*/}
                                                </Chunk>
                                                <Spacer size={{value: 14, unit: "px"}}/>
                                            </>
                                            : null}

                                    {
                                        (data.options.mainOperation) ||
                                        (data.options.distributionChannelsItaly && data.options.distributionChannelsItaly.length > 0) ||
                                        (data.options.exportPercentage) ||
                                        (data.options.exportTo && data.options.exportTo.length > 0) ||
                                        (data.options.desiredExportTo && data.options.desiredExportTo.length > 0) ||


                                        (data.channelsItaly && data.channelsItaly.length > 0) ?
                                            <>
                                                <Chunk title={translations["sheet-company"]["Distribution"]}>
                                                    {data.options.mainOperation ?
                                                        <InfoRow
                                                            label={translations["sheet-company"]["Prevailing operations"]}
                                                            value={data.options.mainOperation[lang]}
                                                        />
                                                        : ""}
                                                    {data.options.distributionChannelsItaly && data.options.distributionChannelsItaly.length > 0 ?
                                                        <InfoRow
                                                            label={translations["sheet-company"]["Distribution channels in Italy"]}
                                                            value={data.options.distributionChannelsItaly.map(val => val[lang]).join(", ")}
                                                        />
                                                        : ""}
                                                    {data.options.exportPercentage ?
                                                        <InfoRow
                                                            label={translations["sheet-company"]["Export percent"]}
                                                            value={data.options.exportPercentage + "%"}
                                                        />
                                                        : ""}
                                                    {data.options.exportTo && data.options.exportTo.length > 0 ?
                                                        <InfoRow
                                                            label={translations["sheet-company"]["Countries to which we export"]}
                                                            value={null}
                                                        >
                                                            <Text cols="3" layout={layout}>
                                                                {data.options.exportTo.map(val =>
                                                                    <span
                                                                        key={`export-to-${val.countryId[lang]}`}>{val.countryId[lang]}{val.distributionChannelIds.length > 0 ? ": " + val.distributionChannelIds.map(val => val[lang]).join(", ") : ""}
                                                                        <br/></span>
                                                                )}
                                                            </Text>
                                                        </InfoRow>
                                                        : ""}
                                                    {data.options.desiredExportTo && data.options.desiredExportTo.length > 0 ?
                                                        <InfoRow
                                                            label={translations["sheet-company"]["Countries where we would like to export"]}
                                                            value={null}
                                                        >
                                                            <Text cols="3" layout={layout}>
                                                                {data.options.desiredExportTo.map(val =>
                                                                    <span
                                                                        key={`desired-export-to-${val.countryId[lang]}`}>{val.countryId[lang]}{val.distributionChannelIds.length > 0 ? ": " + val.distributionChannelIds.map(val => val[lang]).join(", ") : ""}
                                                                        <br/></span>
                                                                )}
                                                            </Text>
                                                        </InfoRow>
                                                        : ""}
                                                </Chunk>
                                                <Spacer size={{value: 14, unit: "px"}}/>
                                            </>
                                            : null}

                                    {/* #region hospitalityFacilities (strutture ricettive) */}
                                    {
                                        (data.options.hospitalityFacilities && data.options.hospitalityFacilities.length > 0) ?
                                            <>
                                                <HospitalityFacilities hospitalityFacilities={data.options.hospitalityFacilities} lang={lang} />
                                                <Spacer size={{value: 14, unit: "px"}}/>
                                            </>
                                            : null}
                                    {/* #endregion */}

                                    {config.areas["products"].enable && data.products && data.products.length > 0 ?

                                        data.products.map((item, index) => (
                                            <React.Fragment key={index}>
                                                <Chunk collapsible={false}>
                                                    <ProductThumb
                                                        key={index}
                                                        item={item}
                                                    />
                                                </Chunk>
                                                <Spacer size={{value: 14, unit: "px"}}/>
                                            </React.Fragment>
                                        ))
                                        : null}


                                    {(data.options.gallery && data.options.gallery.length > 0) || (data.options.video && data.options.video.length > 0) ?
                                        <>
                                            <Chunk title={translations["sheet-company"]["Gallery"]} open={true}>
                                                <Gallery
                                                    images={data.options.gallery && data.options.gallery.length > 0 ? data.options.gallery : []}
                                                    videos={data.options.video && data.options.video.length > 0 ? data.options.video : []}
                                                    lang={lang}
                                                />
                                            </Chunk>
                                            <Spacer size={{value: 14, unit: "px"}}/>
                                        </>
                                        : null}


                                </MacroCol>
                                <MacroCol size="34" layout={layout}>
                                    {hallAndBooth && hallAndBooth.length > 0 && config.enable_halls ?
                                        <>
                                            <FindUs logo={false}>
                                                <HallImageCnt>
                                                    <Image src={theme.halls["void"]} alt=""/>
                                                    {hallAndBooth.map((item, index) =>
                                                        <HallImage key={"hallimage-" + index}>
                                                            <Image src={theme.halls[item.hall]} alt=""/>
                                                        </HallImage>
                                                    )}
                                                </HallImageCnt>
                                                <ReadMore
                                                    visibleContent={hallAndBooth.slice(0, 3).map((item, index) =>
                                                        <Position
                                                            key={`hall-${index}`}>{item.hallName[lang] + (item.booth ? " " + translations["UI"]["Stand"] + " " + item.booth : "")}</Position>
                                                    )}
                                                    hiddenContent={hallAndBooth.slice(3).length ? hallAndBooth.slice(3).map((item, index) =>
                                                        <Position
                                                            key={`hall-${index}`}>{item.hallName[lang] + (item.booth ? " " + translations["UI"]["Stand"] + " " + item.booth : "")}</Position>
                                                    ) : null}
                                                    buttonMore={<Button size={"tiny"} variant={"default-o"}
                                                                        display={"inline-block"}>{translations["UI"]["Show more"]}</Button>}
                                                    buttonLess={<Button size={"tiny"} variant={"default-o"}
                                                                        display={"inline-block"}>{translations["UI"]["Show less"]}</Button>}
                                                />
                                            </FindUs>

                                            <Spacer size={{value: 14, unit: "px"}}/>
                                        </>
                                        : null}


                                    {data.options.brands && data.options.brands.length > 0 ?
                                        <>
                                            <Chunk title={translations["sheet-company"]["Brands"]} collapsible={false}>
                                                {data.options.brands.join(", ")}
                                            </Chunk>
                                            <Spacer size={{value: 14, unit: "px"}}/>
                                        </>
                                        : ""}

                                    {data.relations && data.relations.coexhibs && data.relations.coexhibs.length > 0 ?
                                        <>
                                            <Chunk title={translations["sheet-company"]["Coexhibitors"]}
                                                   collapsible={false}>
                                                <ReadMoreModal
                                                    visibleContent={data.relations.coexhibs.slice(0, 2).map(val =>
                                                        val.id ?
                                                            <Link to={"/" + lang + "/companies/" + val.id} key={val.id}>
                                                                <CompanyResult item={val}/>
                                                            </Link>
                                                            :
                                                            <span key={`coexhibs-${val.name}`}>{val.name}<br/></span>
                                                    )}
                                                    hiddenContent={
                                                        data.relations.coexhibs.length > 2 ?
                                                            <RelationsModal>
                                                                <RelationsModalTitle>
                                                                    {translations["sheet-company"]["Coexhibitors"]}<br/>
                                                                    {data.options.name}
                                                                </RelationsModalTitle>
                                                                <RelationsModalContent layout={layout}>
                                                                    {data.relations.coexhibs.map(val =>
                                                                        <div
                                                                            onClick={() => this.props.dispatch(hideFullModal())}>
                                                                            {val.id ?
                                                                                <Link
                                                                                    to={"/" + lang + "/companies/" + val.id}
                                                                                    key={val.id}>
                                                                                    <CompanyResult item={val}/>
                                                                                </Link>
                                                                                :
                                                                                <span
                                                                                    key={`coexhibs-${val.name}`}>{val.name}<br/></span>
                                                                            }
                                                                        </div>
                                                                    )}
                                                                </RelationsModalContent>
                                                            </RelationsModal>
                                                            : null
                                                    }
                                                    buttonMore={<Button size={"tiny"} variant={"default-o"}
                                                                        display={"inline-block"}>{translations["UI"]["Show more"]}</Button>}>
                                                </ReadMoreModal>
                                            </Chunk>
                                            <Spacer size={{value: 14, unit: "px"}}/>
                                        </>
                                        : null}

                                    {data.relations && data.relations.represents && data.relations.represents.length > 0 ?
                                        <>
                                            <Chunk title={translations["sheet-company"]["Represented"]}
                                                   collapsible={false}>
                                                <ReadMoreModal
                                                    visibleContent={data.relations.represents.slice(0, 2).map(val =>
                                                        val.id ?
                                                            <Link to={"/" + lang + "/companies/" + val.id} key={val.id}>
                                                                <CompanyResult item={val}/>
                                                            </Link>
                                                            :
                                                            <span key={`coexhibs-${val.name}`}>{val.name}<br/></span>
                                                    )}
                                                    hiddenContent={
                                                        data.relations.represents.length > 2 ?
                                                            <RelationsModal>
                                                                <RelationsModalTitle>
                                                                    {translations["sheet-company"]["Represented"]}<br/>
                                                                    {data.options.name}
                                                                </RelationsModalTitle>
                                                                <RelationsModalContent layout={layout}>
                                                                    {data.relations.represents.map(val =>
                                                                        <div
                                                                            onClick={() => this.props.dispatch(hideFullModal())}>
                                                                            {val.id ?
                                                                                <Link
                                                                                    to={"/" + lang + "/companies/" + val.id}
                                                                                    key={val.id}>
                                                                                    <CompanyResult item={val}/>
                                                                                </Link>
                                                                                :
                                                                                <span
                                                                                    key={`coexhibs-${val.name}`}>{val.name}<br/></span>
                                                                            }
                                                                        </div>
                                                                    )}
                                                                </RelationsModalContent>
                                                            </RelationsModal>
                                                            : null
                                                    }
                                                    buttonMore={<Button size={"tiny"} variant={"default-o"}
                                                                        display={"inline-block"}>{translations["UI"]["Show more"]}</Button>}>
                                                </ReadMoreModal>
                                            </Chunk>
                                            <Spacer size={{value: 14, unit: "px"}}/>
                                        </>
                                        : null}

                                    {data.relations && data.relations.coexhibsChild && data.relations.coexhibsChild.length > 0 ?
                                        <>
                                            <Chunk title={translations["sheet-company"]["Coexhibitor of"]}
                                                   collapsible={false}>
                                                <ReadMoreModal
                                                    visibleContent={data.relations.coexhibsChild.slice(0, 2).map(val =>
                                                        val.id ?
                                                            <Link to={"/" + lang + "/companies/" + val.id} key={val.id}>
                                                                <CompanyResult item={val}/>
                                                            </Link>
                                                            :
                                                            <span key={`coexhibs-${val.name}`}>{val.name}<br/></span>
                                                    )}
                                                    hiddenContent={
                                                        data.relations.coexhibsChild.length > 2 ?
                                                            <RelationsModal>
                                                                <RelationsModalTitle>
                                                                    {translations["sheet-company"]["Coexhibitor of"]}<br/>
                                                                    {data.options.name}
                                                                </RelationsModalTitle>
                                                                <RelationsModalContent layout={layout}>
                                                                    {data.relations.coexhibsChild.map(val =>
                                                                        <div
                                                                            onClick={() => this.props.dispatch(hideFullModal())}>
                                                                            {val.id ?
                                                                                <Link
                                                                                    to={"/" + lang + "/companies/" + val.id}
                                                                                    key={val.id}>
                                                                                    <CompanyResult item={val}/>
                                                                                </Link>
                                                                                :
                                                                                <span
                                                                                    key={`coexhibs-${val.name}`}>{val.name}<br/></span>
                                                                            }
                                                                        </div>
                                                                    )}
                                                                </RelationsModalContent>
                                                            </RelationsModal>
                                                            : null
                                                    }
                                                    buttonMore={<Button size={"tiny"} variant={"default-o"}
                                                                        display={"inline-block"}>{translations["UI"]["Show more"]}</Button>}>
                                                </ReadMoreModal>
                                            </Chunk>
                                            <Spacer size={{value: 14, unit: "px"}}/>
                                        </>
                                        : null}

                                    {data.relations && data.relations.representsChild && data.relations.representsChild.length > 0 ?
                                        <>

                                            <Chunk title={translations["sheet-company"]["Representing"]}
                                                   collapsible={false}>
                                                <ReadMoreModal
                                                    visibleContent={data.relations.representsChild.slice(0, 2).map(val =>
                                                        val.id ?
                                                            <Link to={"/" + lang + "/companies/" + val.id} key={val.id}>
                                                                <CompanyResult item={val}/>
                                                            </Link>
                                                            :
                                                            <span key={`coexhibs-${val.name}`}>{val.name}<br/></span>
                                                    )}
                                                    hiddenContent={
                                                        data.relations.representsChild.length > 2 ?
                                                            <RelationsModal>
                                                                <RelationsModalTitle>
                                                                    {translations["sheet-company"]["Representing"]}<br/>
                                                                    {data.options.name}
                                                                </RelationsModalTitle>
                                                                <RelationsModalContent layout={layout}>
                                                                    {data.relations.representsChild.map(val =>
                                                                        <div
                                                                            onClick={() => this.props.dispatch(hideFullModal())}>
                                                                            {val.id ?
                                                                                <Link
                                                                                    to={"/" + lang + "/companies/" + val.id}
                                                                                    key={val.id}>
                                                                                    <CompanyResult item={val}/>
                                                                                </Link>
                                                                                :
                                                                                <span
                                                                                    key={`coexhibs-${val.name}`}>{val.name}<br/></span>
                                                                            }
                                                                        </div>
                                                                    )}
                                                                </RelationsModalContent>
                                                            </RelationsModal>
                                                            : null
                                                    }
                                                    buttonMore={<Button size={"tiny"} variant={"default-o"}
                                                                        display={"inline-block"}>{translations["UI"]["Show more"]}</Button>}>
                                                </ReadMoreModal>
                                            </Chunk>
                                            <Spacer size={{value: 14, unit: "px"}}/>
                                        </>
                                        : null}

                                    {config.areas["events"].enable && data.events.length > 0 ?
                                        <>
                                            <Chunk title={translations["sheet-company"]["Events"]} collapsible={false}>
                                                <ReadMore
                                                    visibleContent={data.events.slice(0, 2).map((item, index) => (
                                                        <Result
                                                            key={index}
                                                            slug={item.slug}
                                                            area="events"
                                                            item={item}
                                                            url={"/" + lang + "/events/" + item.type + "/" + item.id}
                                                        />
                                                    ))}
                                                    hiddenContent={data.events.slice(2).length ? data.events.slice(2).map((item, index) => (
                                                        <Result
                                                            key={index}
                                                            slug={item.slug}
                                                            area="events"
                                                            item={item}
                                                            url={"/" + lang + "/events/" + item.type + "/" + item.id}
                                                        />
                                                    )) : null}
                                                    buttonMore={<Button size={"tiny"} variant={"default-o"}
                                                                        display={"inline-block"}>{translations["UI"]["Show more"]}</Button>}
                                                    buttonLess={<Button size={"tiny"} variant={"default-o"}
                                                                        display={"inline-block"}>{translations["UI"]["Show less"]}</Button>}
                                                />

                                            </Chunk>

                                            <Spacer size={{value: 14, unit: "px"}}/>
                                        </>
                                        : null}
                                </MacroCol>
                            </MacroRow>


                        </Container>
                    </MainContainer>
                </Wrapper>
                {data.options.contacts && data.options.contacts.filter((item) => item.classification._id === "email").length && (
                    <Modal show={showModal} onClose={e => this.toggleModal(false)}>
                        <ContactsModal>
                            <ContactsModalHeader>
                                {/*data.options.logo ?
                  <img src={data.options.logo.src}/>
                  : null*/}
                                <p>{modalText}</p>
                            </ContactsModalHeader>
                            <ContactForm lang={lang} config={config} translations={translations}
                                         company={data.options.name}
                                         reset={!showModal}
                                         toEmail={showModal ? data.options.contacts.filter((item) => item.classification._id === "email").map((item) => item.value) : null}
                                         toName={showModal ? data.options.name : null}
                                         type={showModal ? showModal.type : null}/>
                        </ContactsModal>
                    </Modal>
                )}
            </>
        ) : <></>;

    }

}

export default compose(
    withTheme,
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
)(CompanySheet);
